/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An authentication principal type: agent (ATLAS Agent) oruser (human end-user)
 */
export const AuthPrincipalInfoType = {
  Agent: "agent",
  User: "user",
} as const;
/**
 * An authentication principal type: agent (ATLAS Agent) oruser (human end-user)
 */
export type AuthPrincipalInfoType = OpenEnum<typeof AuthPrincipalInfoType>;

/**
 * Comprehensive information about an ATLAS authentication principal.
 */
export type AuthPrincipalInfo = {
  /**
   * Email of the principal
   */
  email: string;
  /**
   * UUID of the principal
   */
  id: string;
  /**
   * Display name of principal
   */
  name: string;
  /**
   * An authentication principal type: agent (ATLAS Agent) oruser (human end-user)
   */
  type: AuthPrincipalInfoType;
};

/** @internal */
export const AuthPrincipalInfoType$inboundSchema: z.ZodType<
  AuthPrincipalInfoType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AuthPrincipalInfoType);
/** @internal */
export const AuthPrincipalInfoType$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AuthPrincipalInfoType
> = openEnums.outboundSchema(AuthPrincipalInfoType);

/** @internal */
export const AuthPrincipalInfo$inboundSchema: z.ZodType<
  AuthPrincipalInfo,
  z.ZodTypeDef,
  unknown
> = z.object({
  email: types.string(),
  id: types.string(),
  name: types.string(),
  type: AuthPrincipalInfoType$inboundSchema,
});
/** @internal */
export type AuthPrincipalInfo$Outbound = {
  email: string;
  id: string;
  name: string;
  type: string;
};

/** @internal */
export const AuthPrincipalInfo$outboundSchema: z.ZodType<
  AuthPrincipalInfo$Outbound,
  z.ZodTypeDef,
  AuthPrincipalInfo
> = z.object({
  email: z.string(),
  id: z.string(),
  name: z.string(),
  type: AuthPrincipalInfoType$outboundSchema,
});

export function authPrincipalInfoToJSON(
  authPrincipalInfo: AuthPrincipalInfo,
): string {
  return JSON.stringify(
    AuthPrincipalInfo$outboundSchema.parse(authPrincipalInfo),
  );
}
export function authPrincipalInfoFromJSON(
  jsonString: string,
): SafeParseResult<AuthPrincipalInfo, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthPrincipalInfo$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthPrincipalInfo' from JSON`,
  );
}
